import styled from 'styled-components';

export const StyledP = styled.p`
  text-align: center;
  font-weight: bold;
`;

export const ContextItem = styled.span`
  font-weight: bold;
`;

export const S3ErrorContext = styled.ul`
  text-align: center;
  list-style-type: none;
`;

export const StyledApolloErrorSectionCustom = styled.div`
  width: 80%;
  margin: 0 auto;
  text-align: center;
`;
